import React from 'react';

import PropTypes from 'prop-types';

import { Button } from 'apps/auth/components/common/Button/Button';
import { getContacts, hasContacts } from 'apps/auth/components/form-multi/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const Import = (props) => {
    const { importInstructionToImport } = usePageMessages();

    const onClick = () => {
        if (hasContacts()) {
            getContacts()
                .then((contacts) => {
                    if (!!contacts && !!contacts.length) {
                        props.onSelect(contacts.flatMap((contact) => contact.tel));
                    }
                })
                .catch(() => {
                    props.onSelect([]);
                });
        }
    };

    return <Button type="button" caption={importInstructionToImport} variant="row" negativeMargin onClick={onClick} />;
};

Import.propTypes = {
    onSelect: PropTypes.func,
};

export default Import;
